var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaypalImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.525,
    height: 7.034,
    viewBox: "0 0 27.525 7.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paypal-img",
    transform: "translate(-0.5 -24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12940",
    "data-name": "Group 12940",
    transform: "translate(19.462 25.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38550",
    "data-name": "Path 38550",
    d: "M46.216,28.2H44.73a.29.29,0,0,0-.218.175L43.9,32.22a.116.116,0,0,0,.131.131h.786a.116.116,0,0,0,.131-.131l.175-1.092a.2.2,0,0,1,.218-.175h.481a1.522,1.522,0,0,0,1.7-1.442,1.145,1.145,0,0,0-.175-.961,1.762,1.762,0,0,0-1.136-.35m.175,1.442c-.087.524-.481.524-.874.524h-.262l.175-1c0-.044.044-.087.131-.087h.087c.262,0,.524,0,.655.175.087.044.087.175.087.393",
    transform: "translate(-43.9 -28.2)",
    fill: "#139ad6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12941",
    "data-name": "Group 12941",
    transform: "translate(8.758 25.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38551",
    "data-name": "Path 38551",
    d: "M21.716,28.2H20.23a.29.29,0,0,0-.218.175L19.4,32.22a.116.116,0,0,0,.131.131h.7a.29.29,0,0,0,.218-.175l.175-1.049a.2.2,0,0,1,.218-.175h.481a1.522,1.522,0,0,0,1.7-1.442,1.145,1.145,0,0,0-.175-.961,1.679,1.679,0,0,0-1.136-.35m.175,1.442c-.087.524-.481.524-.874.524H20.8l.175-1c0-.044.044-.087.131-.087h.087c.262,0,.524,0,.655.175a.468.468,0,0,1,.044.393",
    transform: "translate(-19.4 -28.2)",
    fill: "#263b80"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12942",
    "data-name": "Group 12942",
    transform: "translate(12.182 27.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38552",
    "data-name": "Path 38552",
    d: "M30.629,31.287h-.7c-.044,0-.131.044-.131.087l-.044.218-.044-.087a1.028,1.028,0,0,0-.83-.306,1.679,1.679,0,0,0-1.617,1.442,1.3,1.3,0,0,0,.262,1.092,1.1,1.1,0,0,0,.918.35,1.4,1.4,0,0,0,1-.393l-.044.218a.116.116,0,0,0,.131.131h.655a.29.29,0,0,0,.218-.175l.393-2.447c-.044-.044-.131-.131-.175-.131m-1,1.4a.845.845,0,0,1-.83.7.7.7,0,0,1-.481-.175.932.932,0,0,1-.131-.524.779.779,0,0,1,1.267-.524.763.763,0,0,1,.175.524",
    transform: "translate(-27.237 -31.2)",
    fill: "#263b80"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12943",
    "data-name": "Group 12943",
    transform: "translate(22.842 27.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38553",
    "data-name": "Path 38553",
    d: "M55.029,31.287h-.7c-.044,0-.131.044-.131.087l-.044.218-.044-.087a1.028,1.028,0,0,0-.83-.306,1.679,1.679,0,0,0-1.617,1.442,1.3,1.3,0,0,0,.262,1.092,1.1,1.1,0,0,0,.918.35,1.4,1.4,0,0,0,1-.393l-.044.218a.116.116,0,0,0,.131.131h.655a.29.29,0,0,0,.218-.175l.393-2.447c-.044-.044-.087-.131-.175-.131m-1,1.4a.845.845,0,0,1-.83.7.7.7,0,0,1-.481-.175.932.932,0,0,1-.131-.524.779.779,0,0,1,1.267-.524.5.5,0,0,1,.175.524",
    transform: "translate(-51.637 -31.2)",
    fill: "#139ad6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12947",
    "data-name": "Group 12947",
    transform: "translate(0.5 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12944",
    "data-name": "Group 12944",
    transform: "translate(15.51 3.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38554",
    "data-name": "Path 38554",
    d: "M39.364,31.4h-.743a.227.227,0,0,0-.175.087l-.961,1.485-.437-1.4a.2.2,0,0,0-.218-.131h-.7c-.087,0-.131.087-.131.175l.786,2.316-.743,1.049c-.044.087,0,.218.087.218h.7A.227.227,0,0,0,37,35.114l2.4-3.452c.131-.131.044-.262-.044-.262",
    transform: "translate(-36 -31.4)",
    fill: "#263b80"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12945",
    "data-name": "Group 12945",
    transform: "translate(25.953 1.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38555",
    "data-name": "Path 38555",
    d: "M60.512,28.365,59.9,32.3a.116.116,0,0,0,.131.131h.612a.29.29,0,0,0,.218-.175l.612-3.845a.116.116,0,0,0-.131-.131h-.7c-.044-.044-.087,0-.131.087",
    transform: "translate(-59.9 -28.261)",
    fill: "#139ad6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12946",
    "data-name": "Group 12946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38556",
    "data-name": "Path 38556",
    d: "M5.524,24.524A2.159,2.159,0,0,0,3.864,24H1.68a.375.375,0,0,0-.306.262L.5,29.986a.2.2,0,0,0,.175.218H2.029l.35-2.141v.087a.375.375,0,0,1,.306-.262H3.34a2.307,2.307,0,0,0,2.534-1.966v-.131h0a1.526,1.526,0,0,0-.35-1.267",
    transform: "translate(-0.5 -24)",
    fill: "#263b80"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12948",
    "data-name": "Group 12948",
    transform: "translate(1.898 25.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38557",
    "data-name": "Path 38557",
    d: "M7.632,28.1h0v.131A2.274,2.274,0,0,1,5.1,30.2H4.443a.375.375,0,0,0-.306.262L3.7,33.124a.16.16,0,0,0,.175.175H5.011a.245.245,0,0,0,.262-.218v-.044l.218-1.354V31.6a.245.245,0,0,1,.262-.218h.175a1.955,1.955,0,0,0,2.185-1.748,1.606,1.606,0,0,0-.218-1.311.447.447,0,0,0-.262-.218",
    transform: "translate(-3.7 -28.1)",
    fill: "#139ad6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12949",
    "data-name": "Group 12949",
    transform: "translate(2.379 25.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38558",
    "data-name": "Path 38558",
    d: "M7.946,27.631c-.044,0-.087-.044-.131-.044a.161.161,0,0,1-.131-.044,2.308,2.308,0,0,0-.568-.044h-1.7a.161.161,0,0,0-.131.044.24.24,0,0,0-.131.218L4.8,30.034v.087a.375.375,0,0,1,.306-.262h.655A2.307,2.307,0,0,0,8.3,27.893a.161.161,0,0,1,.044-.131c-.087-.044-.131-.087-.218-.087-.131-.044-.131-.044-.175-.044",
    transform: "translate(-4.8 -27.5)",
    fill: "#232c65"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalImg);
export default __webpack_public_path__ + "static/media/paypal-img.b809bad5.svg";
export { ForwardRef as ReactComponent };